import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/azka.png";
import SocialMedia from "../SocialMedia";
import TypeWriter from "./TypeWriter";

function Home() {
  const history = useHistory();
  const location = useLocation();

  const navigateTo = (path, id) => {
    // If we're already on the same route, try scrolling to the element first
    if (location.pathname === path) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        // move focus for accessibility
        el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
        return;
      }
      return; 
    }

    history.push(path);
  };
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={6} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Websites That Turn Visitors Into Customers
              </h1>

              <div className="heading-type">
                <TypeWriter />
              </div>

              <p className="heading-description blockquote">
                I help startups and small businesses build and grow web and mobile products—from UX through deployment. One developer, full stack, focused on results that matter to your business.
              </p>

              <div className="home-ctas" style={{ marginTop: 18 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ marginRight: 8 }}
                  onClick={() => navigateTo('/about', 'about')}
                >
                  Free 15‑min audit
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => navigateTo('/project', 'projects')}
                >
                  See projects
                </button>
              </div>

              <div className="trust-line" style={{ marginTop: 12, color: "#6c757d" }}>
                <small>I help startups turn ideas into real web and mobile products and continuously improve them to grow users and revenue faster.</small>
              </div>

            
            </Col>

            <Col md={5}>
              <img src={myImg} className="profile-pic" alt="Azka Bashir avatar" />
            </Col>
          </Row>

          <Row style={{ marginTop: 24 }}>
            <Col md={12}>
              <div className="services-bullets">
                <ul>
                  <li>Websites and apps built to convert visitors into customers</li>
                  <li>Backend systems that scale as your business grows</li>
                  <li>Mobile apps that feel native on iOS and Android</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="home-about-section" id="about">
        <Container>
          <Row>
            <Col md={12} className="home-about-social">
              <h1>Get in Touch</h1>
              <p>
              Have an idea, project, or product you want to improve? I help startups build, fix, and grow web & mobile apps. Book a call and I’ll share a few clear, practical improvements you can apply right away.
              </p>
              <SocialMedia />
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
